import { render, staticRenderFns } from "./FundCommissionRate.vue?vue&type=template&id=ec46a686&scoped=true"
import script from "./FundCommissionRate.vue?vue&type=script&lang=js"
export * from "./FundCommissionRate.vue?vue&type=script&lang=js"
import style0 from "./FundCommissionRate.vue?vue&type=style&index=0&id=ec46a686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec46a686",
  null
  
)

export default component.exports